<script setup lang="ts">

</script>

<template>
  <header>
    <h1>OPNIEUW GEBOUWD</h1>
    <h3>Spelenderwijs door de wederopbouw</h3>
  </header>
</template>

<style scoped>
header {
  height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background-secondary);
  flex-direction: column;
}

h1 {
  font-size: 4rem;
  text-align: center;
}

h3 {
  text-align: center;
}

@media screen and (max-width: 800px) {
  h1 {
    font-size: 2rem;
  }
}
</style>